import React, { useContext, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { Dropdown } from "react-bootstrap";
import LogoutPage from "./Logout";
import ChangePassword from "../../components/Modal/ChangePassword";
import { useDispatch } from "react-redux";
import { triggerToggleAction } from "../../../store/actions/PostActions";
import { ThemeContext } from "../../../context/ThemeContext";
import { FiMoon } from "react-icons/fi";
import { MdPerson, MdSunny } from "react-icons/md";

const Header = ({ onNote }) => {
  const dispatch = useDispatch();
  const pathname = useLocation();
  const { background, changeBackground } = useContext(ThemeContext);
  const [changePassword, setChangePassword] = useState(false);
  const isDark = background?.value === "dark";

  const toggleTheme = () => {
    changeBackground(
      isDark
        ? { value: "light", label: "Light" }
        : { value: "dark", label: "Dark" }
    );
  };

  return (
    <div className="header">
      <ChangePassword
        password={changePassword}
        onHide={() => setChangePassword(false)}
      />

      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              {" "}
              {(pathname.pathname === "/user-details" ||
                pathname.pathname === "/verification-user-details" ||
                pathname.pathname === "/member-details") && (
                <button
                  onClick={() => dispatch(triggerToggleAction(Date.now()))}
                  className="btn btn-primary btn-sm mc-header-action"
                >
                  Capture Screenshot
                </button>
              )}
            </div>
            <ul className="navbar-nav header-right align-items-center">
              <li className="nav-item">
                <button
                  type="button"
                  className="btn btn-link nav-link mc-theme-toggle"
                  onClick={toggleTheme}
                  title={isDark ? "Switch to light mode" : "Switch to dark mode"}
                  aria-label={
                    isDark ? "Switch to light mode" : "Switch to dark mode"
                  }
                >
                  {isDark ? <MdSunny size={20} /> : <FiMoon size={18} />}
                </button>
              </li>
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="i-false c-pointer nav-link mc-header-profile"
                  to=""
                  role="button"
                  data-toggle="dropdown"
                >
                  <div className="header-info">
                    <span>
                      <strong className="text-black">Admin</strong>
                    </span>
                  </div>
                  <div className="mc-header-avatar" aria-hidden="true">
                    <MdPerson size={24} />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="right"
                  className="dropdown-menu dropdown-menu-right"
                >
                  <Link
                    to="#"
                    className="dropdown-item ai-icon"
                    onClick={() => setChangePassword(true)}
                  >
                    <svg
                      id="icon-password"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1={21} y1={12} x2={9} y2={12} />
                    </svg>
                    <span className="ms-2">Change Password</span>
                  </Link>
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
